import { defineEffect } from '../../../core/effect';
import { spec } from '../fx/move';

/** 状況 `move_leave`（組み立ては `../fx/move.js`。arcade はどの状況も同じ絵） */
export default defineEffect({ situation: 'move_leave', role: 'effect', ...spec }, 'move_leave_effect.js');
